<div class="contact-form">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="leftSide" [style.paddingTop.px]="toursId && 23">
      <label for="name"></label>
      <input
        title="Name"
        type="text"
        id="name"
        [placeholder]="'Enter your name' | translate"
        formControlName="name"/>

      <label for="email"></label>
      <input
        title="Email"
        type="email"
        id="email"
        [placeholder]="'Enter email address' | translate"
        formControlName="email"/>

      <label for="phone"></label>
      <input
        title="phone"
        type="tel"
        id="phone"
        [placeholder]="'Enter your phone number' | translate"
        formControlName="phone"/>

      <label for="subject"></label>
      <input
        title="Subject"
        type="text"
        id="subject"
        [placeholder]="'Enter your subject' | translate"
        formControlName="subject"/>
    </div>

    <div class="rightSide">
      @if (toursId) {
        <label for="startDate">{{ "Approximate start date" | translate }}</label>
      }
      @if (tourId || toursId) {
        <input
          title="Start date"
          id="startDate"
          type="date"
          placeholder="Select date"
          [min]="minDate"
          formControlName="bookedDate"/>
      }

      @if (toursId) {
        <label for="endDate">{{ "Approximate end date" | translate }}</label>
        <input
          title="End Date"
          id="endDate"
          type="date"
          placeholder="Select date"
          [min]="minDate"
          formControlName="endBookedDate"/>
      }

      <label for="message"></label>
      <textarea
        title="Message"
        id="message"
        [placeholder]="'Message' | translate"
        cols="30"
        rows="10"
        formControlName="message"
      ></textarea>

      <button>{{ "send" | translate }}<i class="fas fa-arrow-right buttonIcon"></i></button>
    </div>
  </form>

  <div class="form-state-message">
    @if (messageState === 'success') {
      <p class="success">
        {{ successMessage | translate }}
      </p>
    }
    @if ( messageState === 'error') {
      <p class="error">{{ "An error has occurred" | translate }}</p>
    }
  </div>
</div>
